import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { PracticesService } from '../../../../api/services/practices.service'
import { ManageRoles } from '../../../../api/models'

@Injectable({
  providedIn: 'root',
})
export class GroupResolver {
  constructor(private practiceService: PracticesService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any[]> {
    let practiceId = route.paramMap.get('practice_id')

    return this.practiceService.practicesGetAllGroups({
      practiceId: practiceId,
    })
  }
}
